<template>
  <div>

    <div class="flex items-center justify-between" style="height: 40px">
      <div class="h-full flex items-center">
        <el-dropdown>
          <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
            :class="{ 'shadow-sm': sortList }" style="width: 40px; height: 40px; background-color: #f7fafd">
            <sort-icon />
          </button>
          <el-dropdown-menu slot="dropdown" placement="right-end">
            <el-dropdown-item disabled>SORT BY</el-dropdown-item>

            <el-dropdown-item>
              <button @click="setSortOrder('ASC')" class="flex items-center">ASC</button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="setSortOrder('DESC')" class="flex items-center">
                DESC
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="flex items-center mr-8">
          <div class="table__search-input-wrapper">
            <span class="pr-2">
              <search-icon />
            </span>

            <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />

            <!-- <search-drop-down-icon /> -->
            <div @click="showSearchFilter = true" class="cursor-pointer"><search-drop-down-icon /></div>
          </div>
        </div>

      </div>

      <div class="date-picker flex items-center justify-center">
        <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />

        <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
      </div>
    </div>

    <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh"
      v-if="loadingDispatches">
      <loader />
    </div>

    <!-- <div v-else-if="!dispatches && !dispatches.length"
      class="flex flex-col items-center gap-2 justify-center p-5 bg-white w-100">
      <empty-booking-icon />
      <p>No Dispatches Currently</p>
    </div> -->

    <div v-if="!loadingDispatches" class="table-values" >
      <div v-if="dispatches.length > 0" class="table-wrapper" id="table-wrapper">
        <table class="custom-table responsive-table">
          <thead>
            <tr>
              <th class="width-xs"><input type="checkbox" class="checkbox">
              </th>
              <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>
              <th class="relative width-xs" tabindex="-1">
                <span class="cursor-pointer" @click="showFilterModal = true">
                  <img src="../../../../assets/images/icons/options-icon.png" class="inline-block" />
                </span>
              </th>
            </tr>
          </thead>
          <!-- <TablerowBase class="mt-3" :paginatedList="paginatedList" :shippingServices="shippingServices"
          @refetch-dispatch="getDisp()" :dispatch="dispatch" :currentTab="currentTab" :locations="locations"
          :activeHeaders="activeHeaders" /> -->
          <tbody>
            <tr v-for="dispatch in paginatedList" :key="dispatch.id">
              <td><base-checkbox class="" label="" v-model="terms_of_use" :bold="true" /></td>
              <td v-for="header in activeHeaders" :key="header">
                 <span v-if="header.name === 'ORIGIN'">
                  {{ getLocationDetails(dispatch.origin).locationName }}
                </span>
            

                 <span v-else-if="header.name === 'DESTINATION'">
                  <!-- {{ getLocationDetails(dispatch.consolidation.destination).locationName }} -->
                </span>
                <span v-else-if="header.name === 'DRIVER'">
                  {{ dispatch && 
              dispatch &&
                dispatch.fleet &&
                dispatch.fleet.driver &&
                 dispatch.fleet.driver.firstname
                 ?dispatch.fleet.driver.firstname
                :
                "N/A" }}
                {{ dispatch && 
              dispatch &&
                dispatch.fleet &&
                dispatch.fleet.driver &&
                 dispatch.fleet.driver.lastname
                 ?dispatch.fleet.driver.lastname
                :
                "N/A" }}
                </span>
                 <span 
                class="rounded-xl overflow-wrap p-2 px-4 text-center bg-[#09B38A]"
                  :class="{ 'status-green': dispatch.dispatchStatus == 'dispatched' || dispatch.dispatchStatus == 'received' || dispatch.dispatchStatus == 'process_handoff', 'status-yellow': dispatch.dispatchStatus == 'loading', 'status-pale': dispatch.dispatchStatus == 'ready', 'status-any': dispatch.dispatchStatus == 'on-hold' || dispatch.dispatchStatus == 'in-bound', 'status-red': dispatch.dispatchStatus == 'accidented' || dispatch.dispatchStatus == 'delayed' }"
                  v-else-if="header.name === 'FLEET STATUS'">
                  {{ dispatch.dispatchStatus == "received" && currentTab == "outgoing" ? 'Handed-off' :
                  dispatch.dispatchStatus == "received" && currentTab == "incoming" ?
                  capitalize(dispatch.dispatchStatus) : capitalize(dispatch.dispatchStatus) }}
                </span> 
                <span v-else>
                  {{ getNestedValue(dispatch, headerMap[header.name]) }}
                </span>
                
              </td>

              <td>

                <el-dropdown trigger="click" placement="top" @command="showModal">
                    <button class="p-2 -mt-2 list-button w-full text-right text-[#6E6893] gap-4 rounded-md">
                        <img src="../../../../assets/images/icons/more-action-icon.png">
                    </button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img
                                        src="../../../../assets/images/icons/view-details-manifest.png" class=""></div>

                                <p class=""
                                    @click="$router.push({ name: 'DispatchManifest', params : { dispatchID : dispatch.id } } )">
                                    View Manifest</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="onDispatch" v-if="currentTab == 'outgoing'"
                            command="dispatchmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/delivery-truck.png"
                                        class=""></div>

                                <p class="">Dispatch</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div
                                @click="$router.push({ name: 'DispatchTimeline' ,params : { dispatchID : dispatch.id }})">
                                <button class="flex flex-nowrap w-full p-1 text-left">
                                    <div class="pt-2 mr-3"><img
                                            src="../../../../assets/images/icons/view-details-timeline.png" class="">
                                    </div>

                                    <p class="">View Timeline</p>
                                </button>
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'"  command="statusmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/update-arrows.png"
                                        class=""></div>

                                <p class="">Update Status</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'" command="processhandoffmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/hand-shake.png"
                                        class=""></div>

                                <p class="">Process Handoff</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'incoming'" command="receiveshipmentmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/hand-shake.png"
                                        class=""></div>

                                <p class="">Receive Shipment</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item hidden v-if="currentTab == 'outgoing'" command="showProcessFulfillmentModal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img
                                        src="../../../../assets/images/icons/process-fulfillment-icon.png" class="">
                                </div>

                                <p class="">Process Fulfillment</p>
                            </button>
                        </el-dropdown-item>

                        <el-dropdown-item :disabled="onDispatch" v-if="currentTab == 'outgoing'"
                            command="putonholdmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <img src="../../../../assets/images/icons/hand-up.png" class="mr-1">
                                <p class="">Put on Hold</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'" :disabled="onDispatch"
                            command="canceldispatch">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/cancel-icon.png"
                                        class=""></div>

                                <p class="">Cancel</p>
                            </button>
                        </el-dropdown-item>

                    </el-dropdown-menu>
                </el-dropdown>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else
      class="flex flex-col items-center gap-2 justify-center p-5 bg-white w-100">
      <empty-booking-icon />
      <p>No Dispatches Currently</p>
    </div>
    </div>

    
    <!-- <div v-if="showupdateModal"><UpdateStatusModal :currentStatus="isOnDispatch" /></div> -->
     <UpdateStatusModal :showmodal="showupdateModal"  @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="showupdateModal = false"  :statuses="statuses" />
    <ConfirmHandoffModal :showModal="confirmhandoffModal" :processObj="processObj" :dispatch="dispatch"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="confirmhandoffModal = false" />

    <put-on-hold-modal :fleetId="selectedFleetId" @dispatch-paused="getAllFleets" :showModal="showHoldModal"
      @close-modal="showHoldModal = false" />

      <DSF @appliedRef="appliedReference" :show-modal="showSearchFilter" @close-modal="showSearchFilter = false"
      :loading="loading" :dispatches="paginatedList" />

    <pagination-control :total="totalDispatch" :pageNumber="pageNumber" @pageNumber="setNumDisplayDispatch"
      @pageSize="pageSizeSet" />

    <DispatchTableFilter :show-modal="showFilterModal" :activeHeaders="activeHeaders"
      @close-modal="showFilterModal = false" />
      <ProcessHandOffModal :showModal="processhandoffModal" :dispatch="dispatch"
                @refetch-dispatch="$emit('refetch-dispatch')" @show-confirm-handoff="showConfirmHandoff"
                @close-modal="processhandoffModal = false" />
  </div>
</template>

<script>
//   import ProcessFulfillmentModal from "./Modals/ProcessFulfillmentModal"
// import ReturnDetailsModal from "./Modals/ReturnDetailsModal"
// import ReturnCostModal from "./Modals/ReturnCostModal"
// import DispatchModal from "./Modals/DispatchModal"
import UpdateStatusModal from "./Modals/UpdateStatusModal"
// import PutOnHoldModal from "./Modals/PutOnHoldModal"
// import CancelDispatchModal from "./Modals/CancelDispatchModal"
// import FinalPutOnHoldModal from "./Modals/FinalPutOnHoldModal"
// import ConfirmFulfillmentModal from "./Modals/ConfirmFulfillmentModal.vue";
// import RequestSentModal from "./Modals/RequestSentModal";
import ProcessHandOffModal from "./Modals/ProcessHandoffModal";
import ConfirmHandoffModal from "./Modals/ConfirmHandoffModal";
// import ReceiveShippingModal from "./Modals/ReceiveShippingModal.vue";
import DSF from "./Modals/DispatchSearchFilter.vue"

import PaginationControl from "@/components/UI/pagination";
// import TablerowBase from "./TablerowBase";
import PutOnHoldModal from "@/components/3pl/Operations/Dispatch/Modals/PutOnHoldModal.vue";
import moment from "moment";
import DispatchTableFilter from "./Modals/DispatchTableFilter.vue";


export default {
  props: ["currentTab"],
  components: {
    DSF,
    //  ProcessFulfillmentModal,
    //     ReturnDetailsModal,
    //     ReturnCostModal,
    //     DispatchModal,
        UpdateStatusModal,
    //     PutOnHoldModal,
    //     CancelDispatchModal,
    //     FinalPutOnHoldModal,
    //     ConfirmFulfillmentModal,
    //     RequestSentModal,
        ProcessHandOffModal,
        ConfirmHandoffModal,
    //     ReceiveShippingModal,

    DispatchTableFilter,
    PaginationControl,
   // TablerowBase,
    PutOnHoldModal,
  },
  data() {
    return {
      showSearchFilter: false,
      confirmhandoffModal : false,
      showupdateModal: false,
      terms_of_use : false,
      statuses:[
                {
                    name: 'Received',
                    value: 'received'
                },
                {
                    name: 'Ready',
                    value: 'ready'
                },
                {
                    name: 'Accidented',
                    value: 'accidented'
                },
                {
                    name: 'Delayed',
                    value: 'delayed'
                },
                {
                    name: 'In-bound',
                    value: 'in-bound'
                },
                {
                    name: 'Dispatched',
                    value: 'dispatched'
                },
                {
                    name: 'On-hold',
                    value: 'on-hold'
                },
            ],
      //    terms_of_use : false,
      //       showactions : false,
      //       statusDispatch : false,
      //       putholdModal : false,
      //       showfinalholdmodal : false,
      //       successfulDispatch : false,
      //       showupdateModal : false,
            processhandoffModal :false,
      //       showProcessFulfillmentModal : false,
      //       confirmprocesshandoffModal : false,
      //       requestsentModal : false,
      //       processreturnmodal : false,
      //       returndetailsmodal : false,
      //       returncostmodal : false,
      //       canceldispatchshow : false,
      //       showConfirmFulfilment : false,
      //       showRequestSentModal : false,
      //       confirmhandoffModal : false,
      //       showReceiveShippingModal: false,
      //       putonholdreason : "",
      //       booking : {},
      //       deliveryDate : new Date(),
      //       user : {},
      //       messageId: "",
        
      showFilterModal: false,
      selectedFleetId: null,
      fleets: [],
      removedTableData: [],
      isLoading: false,
      isTableFilter: false,
      showHoldModal: false,
      date: 0,
      location: "null",
      queryString: null,
      sortList: false,
      startDate: "",
      endDate: "",
      shippingServices: [],
      dispatches: [],
      loadingDispatches: true,
      sortOrder: "ASC",
      pageSize: 10,
      sortColumn: "",
      totalDispatch: 1,
      dispatchPerPage: 10,
      pageNumber: 1,
      locations: [],
      activeHeaders: [
        { name: "DISPATCH REF." },
        { name: "FLEET NAME" },
        { name: "FLEET REG NO." },
        { name: "DRIVER" },
        { name: "ORIGIN" },
        { name: "DESTINATION" },
        { name: "LOAD CAPACITY" },
        { name: "FLEET STATUS" },
      ],
      headerMap: {
        "DISPATCH REF.": 'dispatchReference',
        "FLEET NAME": 'fleet.equipment',
        "FLEET REG NO.": 'fleet.vinnumber', 
        "DRIVER": '',
        'ORIGIN': '',
        'DESTINATION': '', 
        "LOAD CAPACITY": 'fleet.currentLoadCapacity',
        "FLEET STATUS": 'dispatchStatus',
        "Load status": 'consolidation.status',
        "Estimated drop off date": '',
        "Estimated drop off time": '',
      },
    };
  },
  computed: {
//     isOnDispatch(dispatch) {
//   const validStatuses = ['dispatched', 'accidented', 'received', 'delayed'];
//   return validStatuses.includes(dispatch?.dispatchStatus);
// },
    isOnDispatch(dispatch) {
  const validStatuses = dispatch?.dispatchStatus;
  return validStatuses;
},

    onDispatch() {
  const validStatuses = ['dispatched', 'accidented', 'received', 'delayed'];

  return this.dispatches?.some(
    dispatch => validStatuses.includes(dispatch.dispatchStatus)
  ) || false;
},

    dispatchReadyFleets() {
      let fleetsWithShippingServices = this.fleets.filter((fleet) => {
        return fleet.shippingService;
      });

      return fleetsWithShippingServices;
    },
    dispatchesList() {
      return this.dispatches;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.dispatchPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.dispatchPerPage);
    },
    paginatedList() {
      return this.dispatches.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return { pageSize: this.dispatchPerPage, pageNum: this.pageNumber };
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    }
  },
  watch: {
    currentTab() {
      this.getDispatches({ dispatchType: this.currentTab, terminalId: this.locationId });
    },
    setparams() {
      this.loading = true;
      this.getDispatches({ dispatchType: this.currentTab });
    },
    queryString() {
      this.getDispatches({
        dispatchType: this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    sortColumn() {
      this.getDispatches({
        dispatchType: this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    locationId() {
      this.getDispatches({
        dispatchType: this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    sortOrder() {
      this.getDispatches({
        dispatchType: this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    pageSize() {
      this.getDispatches({
        dispatchType: this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.getDispatches({
          dispatchType: this.currentTab,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder,
          pageSize: this.pageSize,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getDispatches({
          dispatchType: this.currentTab,
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getDispatches({
          dispatchType: this.currentTab,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getDispatches({
          dispatchType: this.currentTab,
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }
    },
  },
  mounted() {
    this.getAllFleets();
    this.getDispatches({ dispatchType: this.currentTab, terminalId: this.locationId });
    this.getAllLocations();
  },

  methods: {
     appliedReference (filteredVal) {
      this.query = filteredVal
    },

    showModal(modal){
    
                if(modal == 'dispatchmodal'){
                    this.statusDispatch = true
                }else if(modal == 'putonholdmodal'){
                    this.putholdModal = true
                }else if(modal == 'statusmodal'){
                  console.log("update status modal", this.showupdateModal)
                    this.showupdateModal = !this.showupdateModal
                }else if(modal == 'processhandoffmodal'){
                    this.processhandoffModal = true
                }else if(modal == 'processreturnModal'){
                    this.processreturnmodal = true
                }else if(modal == 'canceldispatch'){
                    this.canceldispatchshow = true
                }else if(modal == 'showProcessFulfillmentModal'){
                    this.showProcessFulfillmentModal = true
                }else if(modal == 'receiveshipmentmodal'){
                    this.showReceiveShippingModal = true
                }
            },
    //         showConfirmHandoff(processObj) {
    //             this.processObj = processObj;
    //             console.log(processObj)
    //             this.confirmhandoffModal = true;
    //         },
       getNestedValue(obj, path) {
            const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
            return value === null || value === undefined || value === '' ? 'N/A' : value;
        }, 
        capitalize(str){
            let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)
            return capitalizedstr
        },
    getDisp() {
      this.getDispatches({ dispatchType: this.currentTab, terminalId: this.locationId });

    },
    setSortOrder(val) {
      this.sortOrder = val;
    },
    pageSizeSet(val) {
      this.dispatchPerPage = val;
    },
    setNumDisplayDispatch(val) {
      this.pageNumber = val;
    },
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 10000;
    },
    viewManifest(fleet) {
      localStorage.setItem("selectedFleet", JSON.stringify(fleet));
      this.$router.push({ name: "DispatchManifest" });
    },
    toggleActions(id) {
      if (this.showActions) {
        this.showActions = null;
      } else {
        this.selectedFleetId = id;
      }
    },
    getAllLocations() {
      try {
        this.$_getAllLocations().then((response) => {
          this.locations = response.data.data.locations;
          this.$store.dispatch("saveOrgLocations", response.data.data.locations)
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllFleets() {
      try {
        const response = await this.$_getAllFleets();
        this.fleets = response.data.data.allFleets;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDispatches({
      dispatchType,
      startDate,
      endDate,
      sortOrder,
      search,
      pageSize,
      sortColumn,
      terminalId
    }) {
      this.loadingDispatches = true;
      try {
        let response = {};
        let payload = {
          dispatchType,
          startDate,
          endDate,
          sortOrder,
          search,
          pageSize,
          sortColumn,
          terminalId
        }

        if (payload.terminalId == undefined) {
          delete payload.terminalId
        }
        response = await this.$_getDispatches(payload);

        this.dispatches = response.data.dispatches;
        this.totalDispatch = response.data.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingDispatches = false;
      }
    },
    async dispatchFleet() {
      this.generateToast("Dispatching fleet", "success");
      try {
        await this.$_dispatchFleet(this.selectedFleetId);
        this.getAllFleets();
        this.generateToast("Fleets successfully dispatched!", "success");
      } catch (error) {
        this.handleError(error);
      }
    },
    perPageSize(pageSize) {
      this.pageSize = pageSize;
    },

  },
};
</script>


<style lang="scss" scoped>
  .table-values{
    p{
        font-weight: 500;
    }
    .status-green{
        background-color : #09B78A33;
        color : #09B78A;
        font-size: 14px
    }
    .status-yellow{
        background-color: #FFA60033;
        color : #FFA600;
        font-size : 14px
    }
    .status-pale{
        background-color: #10233E33;
        color : #10233E;
        font-size : 14px
    }
    .status-any{
        background-color: #FFA60033;
        color : #FFA600;
        font-size: 14px
    }
    .status-red{
        background-color: #D7263833;
        color: #D72638;
        font-size: 14px;
    }
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
}


#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}


th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
}

// .width-md {
//   min-width: 5rem;
// }

// .width-sm {
//   min-width: 8rem;
// }

.width-xs {
  min-width: 3rem !important;
}



td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

}




.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
  border: 1px solid #dae8f6;
  border-radius: 5px;
  height: 40px;
}
</style>
